"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _config = require("@trs/config");
var _MediaCreator = _interopRequireDefault(require("./MediaCreator"));
var _MediaObject = _interopRequireDefault(require("./MediaObject"));
var _EditMenu = _interopRequireDefault(require("./EditMenu"));
var _icon = _interopRequireDefault(require("../icon"));
var _helpers = require("./helpers");
var _StyledBanner = require("./StyledBanner.style");
var _InputError = _interopRequireDefault(require("../errors/InputError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Banner = /*#__PURE__*/function (_Component) {
  function Banner(props) {
    var _this;
    _classCallCheck(this, Banner);
    _this = _callSuper(this, Banner, [props]);
    _defineProperty(_this, "handleMediaCreatorPopup", function () {
      var handleDuringEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props = _this.props,
        disabled = _this$props.disabled,
        src = _this$props.src;
      var emptyBanner = R.isNil(src) || R.isEmpty(src);
      if ((emptyBanner || handleDuringEdit) && !disabled) {
        _this.setState(function (prevProps) {
          return {
            creatorOpen: !prevProps.creatorOpen
          };
        });
      }
    });
    _defineProperty(_this, "onMouseEnterHandler", function () {
      _this.setState({
        showMoreIcon: true
      });
    });
    _defineProperty(_this, "onMouseLeaveHandler", function () {
      _this.setState({
        showMoreIcon: false
      });
    });
    _defineProperty(_this, "handleMediaEditMenu", function () {
      _this.setState(function (prevProps) {
        return {
          editMenuOpen: !prevProps.editMenuOpen
        };
      });
    });
    _defineProperty(_this, "onEditLink", function () {
      _this.handleMediaEditMenu();
      _this.handleMediaCreatorPopup(true);
    });
    _defineProperty(_this, "onDeleteLink", function () {
      _this.handleMediaEditMenu();
      _this.props.onChange({
        src: '',
        alt: ''
      });
    });
    _this.state = {
      creatorOpen: false,
      showMoreIcon: false,
      editMenuOpen: false
    };
    return _this;
  }
  _inherits(Banner, _Component);
  return _createClass(Banner, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        creatorOpen = _this$state.creatorOpen,
        showMoreIcon = _this$state.showMoreIcon,
        editMenuOpen = _this$state.editMenuOpen;
      var _this$props2 = this.props,
        type = _this$props2.type,
        src = _this$props2.src,
        alt = _this$props2.alt,
        disabled = _this$props2.disabled,
        labels = _this$props2.labels,
        supportedMediaTypes = _this$props2.supportedMediaTypes,
        recommendedMediaSizes = _this$props2.recommendedMediaSizes,
        images = _this$props2.images,
        videoPlatformAccepted = _this$props2.videoPlatformAccepted,
        readOnly = _this$props2.readOnly,
        error = _this$props2.error;
      var mediaIcon = images.mediaIcon,
        disabledMediaIcon = images.disabledMediaIcon,
        badImageURL = images.badImageURL;
      var hasError = !(0, _utils.isBlank)(error);
      var emptyBanner = R.isNil(src) || R.isEmpty(src);
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_StyledBanner.StyledBanner, {
        readOnly: readOnly,
        onMouseEnter: this.onMouseEnterHandler,
        onMouseLeave: this.onMouseLeaveHandler
      }, !readOnly && /*#__PURE__*/_react["default"].createElement(_StyledBanner.StyledMediaHandler, {
        onClick: function onClick() {
          return _this2.handleMediaCreatorPopup(false);
        },
        className: (0, _classnames["default"])({
          disabled: !emptyBanner || disabled
        })
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: !emptyBanner || disabled ? disabledMediaIcon : mediaIcon,
        alt: "media",
        className: "media-helper-icon"
      }), /*#__PURE__*/_react["default"].createElement("p", {
        className: "helper-text"
      }, labels.ADD_MEDIA)), creatorOpen && /*#__PURE__*/_react["default"].createElement(_MediaCreator["default"], {
        componentName: _helpers.MEDIA_COMPONENTS.BANNER,
        supportedMediaTypes: supportedMediaTypes,
        onClose: function onClose() {
          return _this2.handleMediaCreatorPopup(true);
        },
        onChange: this.props.onChange,
        type: type,
        src: src,
        alt: alt,
        labels: labels,
        recommendedMediaSizes: recommendedMediaSizes,
        videoPlatformAccepted: videoPlatformAccepted
      }), hasError && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
        className: "rdw-inputError",
        message: error
      }), !R.isNil(src) && !R.isEmpty(src) && /*#__PURE__*/_react["default"].createElement(_StyledBanner.StyledMediaContainer, null, /*#__PURE__*/_react["default"].createElement(_StyledBanner.StyledMedia, null, showMoreIcon && !disabled && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        className: "more-icon icon-ion-android-more-vertical",
        size: 24,
        onClick: this.handleMediaEditMenu
      }), editMenuOpen && /*#__PURE__*/_react["default"].createElement(_EditMenu["default"], {
        onClose: this.handleMediaEditMenu,
        onEdit: this.onEditLink,
        onDelete: this.onDeleteLink
      }), /*#__PURE__*/_react["default"].createElement(_MediaObject["default"], {
        type: type,
        src: src,
        alt: alt,
        readOnly: readOnly,
        imageFallback: badImageURL,
        recommendedMediaSizes: recommendedMediaSizes[_helpers.MEDIA_COMPONENTS.BANNER]
      })))), !emptyBanner && readOnly && alt && /*#__PURE__*/_react["default"].createElement("p", {
        className: "media-object-title"
      }, alt));
    }
  }]);
}(_react.Component);
Banner.defaultProps = {
  readOnly: false,
  recommendedMediaSizes: {},
  type: _config.MEDIA_TYPE.IMAGE,
  src: '',
  alt: '',
  videoPlatformAccepted: [],
  error: undefined
};
Banner.propTypes = {
  readOnly: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  src: _propTypes["default"].string,
  alt: _propTypes["default"].string,
  disabled: _propTypes["default"].bool.isRequired,
  labels: _propTypes["default"].shape({
    ADD_MEDIA: _propTypes["default"].string
  }).isRequired,
  recommendedMediaSizes: _propTypes["default"].shape({}),
  supportedMediaTypes: _propTypes["default"].shape({}).isRequired,
  images: _propTypes["default"].shape({
    mediaIcon: _propTypes["default"].string,
    disabledMediaIcon: _propTypes["default"].string,
    badImageURL: _propTypes["default"].string
  }).isRequired,
  error: _propTypes["default"].string,
  videoPlatformAccepted: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
var _default = exports["default"] = Banner;